import React from "react";

import CoveragePortfolio from
  "../../../components/risk_financing/coverage/CoveragePortfolio";

import useRiskFinancingContext from
  "../context/useRiskFinancingContext";
import { useAccess } from "../../../access/AccessContext";
import { PERMISSIONS } from "../../../access/capabilities";


export default function RiskFinancingCoverageTab({
  settings,
}) {

  const access = useAccess();
  const {
    coverage,
  } = useRiskFinancingContext();

  const {
    portfolio,
    scenarios,
    adequacy,

    state,

    actions,
  } = coverage;

  return (
    <CoveragePortfolio
        coverages={portfolio}
        activeFairScenarios={scenarios}

        settings={settings}

        loading={state.portfolioLoading}
        mutationLoading={state.mutationLoading}
        error={state.portfolioError}

        activeScenariosLoading={state.scenariosLoading}
        activeScenariosError={state.scenariosError}

        coverageAdequacyData={adequacy}
        coverageAdequacyLoading={state.adequacyLoading}
        coverageAdequacyError={state.adequacyError}

        canAdd={access.hasPermission(PERMISSIONS.financing.add)}
        canChange={access.hasPermission(PERMISSIONS.financing.change)}
        canDelete={access.hasPermission(PERMISSIONS.financing.delete)}
        canExecute={access.hasPermission(PERMISSIONS.financing.execute)}
        onCreateCoverage={actions.create}
        onUpdateCoverage={actions.update}
        onChangeCoverageStatus={actions.changeStatus}
        onDeleteCoverage={actions.remove}

        onLinkScenario={actions.linkScenario}
        onUnlinkScenario={actions.unlinkScenario}

        onRefreshCoverageAdequacy={
            actions.refreshAdequacy
        }

        onAnalyzeCoverageScenario={
            actions.analyzeScenario
        }
    />
  );
}